style= require('./event-submitter.styl')

section
  .sub-types.radio-collection
    each type, $index in subTypes
      .item
        ft-toggle(
          type="radio",
          (change)=this.selectSubType(type),
          checked=(type == this.event.subType))
          span.sub-type= this.state.eventName(type)
    if this.state.easyNameChange
      span Rename
      each type, $index in this.state.easyNameChange
        .item
          ft-toggle(
            type="radio",
            (change)=this.changeName(type),
            checked=(type == this.event.name))
            span.sub-type= this.state.eventName(type)
  
  if isBatched
    .batch-label
      span Batch
      select(
        [value]=this.event.batch,
        (input)=this.assignBatch(e.target.value)
      )
        each number in [1,2,3,4,5]
          option(value=number)= number 
  if minuteNeedsConversion
    .round-label
      span Round
      select(
        [value]=this.state.round,
        (input)=this.adjustMinute(e.target.value)
      )
        each index in Array.from({ length: 50}, (_, i) => i)
          option(value=index)= index
  .minutes
    if durations.length
      .penalty-label
        span= durationLabel
      select(
        [value]=this.event.duration,
        (input)=this.assignDuration(e.target.value)
      )
        each duration in durations
          option(value=duration)= duration
    
    .minutes-label
      span= minuteLabel
      select(
        [value]=this.minute,
        (input)=this.assignMinute(e.target.value)
      )
        if isPreMatch
          optgroup(label="Pre-match")
            option(value=0) 0
        - var displayMinute = this.displayMinute

        each round in rounds
          optgroup(label=this.roundLabel(round))
            - var min = this.roundStart(round)
            - var end = this.roundEnd(round)
            each index in Array.from({ length: end - min }, (_, i) => i + min)
              option(value=index)= displayMinute(index, min, round)
        optgroup(label="Post-match")
          option(value=lastMinute)= lastMinute
    if isSeconds
      .seconds-label
        span Seconds
        select(
          [value]=this.event.second,
          (input)=this.assignSecond(e.target.value)
        )
          each sec in Array.from({ length: 60 }, (_, i) => i)
            option(value=sec)= sec
  .submit((click)=this.submit())
    ft-button(success disabled=!isReady) Submit Event
